import {PERCORSOTARIFFA} from './PercorsoTariffaTypes'

const initialState = {
    percorsoTariffa : false
}

const PercorsoTariffaReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case PERCORSOTARIFFA:
            
            return {
                percorsoTariffa : action.load
            }
    
        default:
          return state
    }

}

export default PercorsoTariffaReducer;